import React from 'react';
import PropTypes from 'prop-types';
import singleOrMultiple from '../../utils/singleOrMultiple';
import IconWithText from '../Global/Icons/IconWithText';

const DrillSetUp = ({ content }) => {
  const { time, number_of_players, balls, bibs, cones, area_size } = content;
  let setUp;

  if (time > 0 ||
    number_of_players > 0 ||
    balls > 0 ||
    bibs > 0 ||
    cones > 0 ||
    area_size) {
    setUp = (
      <div className="drill-set-up-info">
        <h2 className="h1 fw-bold">Set Up</h2>
        <ul className="inline-list-spaced">
          {time > 0 &&
            <li><IconWithText name="clock" size="m" fill="black">{`${time} ${singleOrMultiple('min', time)}`}</IconWithText></li>
          }
          {number_of_players > 0 &&
            <li><IconWithText name="shirt" size="m" fill="black">{`${number_of_players} ${singleOrMultiple('player', number_of_players)}`}</IconWithText></li>
          }
          {balls > 0 &&
            <li><IconWithText name="ball" size="m" fill="black">{`${balls} ${singleOrMultiple('ball', balls)}`}</IconWithText></li>
          }
          {bibs > 0 &&
            <li><IconWithText name="bib" size="m" fill="black">{`${bibs} ${singleOrMultiple('bib', bibs)}`}</IconWithText></li>
          }
          {cones > 0 &&
            <li><IconWithText name="cone" size="m" fill="black">{`${cones} ${singleOrMultiple('cone', cones)}`}</IconWithText></li>
          }
          {area_size &&
            <li><IconWithText name="area-size" size="m" fill="black">{`${area_size} area`}</IconWithText></li>
          }
        </ul>
      </div>
    );
  } else {
    setUp = null;
  }

  return setUp;
};

DrillSetUp.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

export default DrillSetUp;



// WEBPACK FOOTER //
// ./library/app/components/Drill/DrillSetUp.js